import React, { useContext } from 'react';
import { t, defineMessages } from '@sm/intl';
import { getHelpCenterLink, StaticContext } from '@sm/webassets';
import { TopBarSlim } from '../TopBarSlim';
import { Link, Typography } from '@sm/wds-react';

const COPY = defineMessages({
  MESSAGE: {
    id: 'DomainLockdownTeamTopBarSlim.message',
    defaultMessage:
      'Great news - your company now offers an Enterprise plan. To join them please contact your Primary Admin or { ctaText }.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'DomainLockdownTeamTopBarSlim.ctaText',
    defaultMessage: 'customer support',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
  BOLD_PREFIX: {
    id: 'DomainLockdownTeamTopBarSlim.prefix',
    defaultMessage: 'ANNOUNCEMENT:',
    description: '[Type: Header][Vis.: low] - Top bar slim prefix',
  },
});

export const DomainLockdownTeamTopBarSlim: React.FC = () => {
  const {
    user: { languageCode },
  } = useContext<{ user: { languageCode: unknown } }>(StaticContext);
  const url = getHelpCenterLink(languageCode, {
    path: 'contact',
    params: {
      form: 'domain',
      ut_source: 'topbar',
      ut_source2: 'domain_lockdown_team',
    },
  });

  // The CTA is displayed as part of the message.
  const ctaText = (
    <Link
      className="wds-display--inline-block"
      href={url}
      target="_blank"
      key="DomainLockdownTeamTopBarSlim__cta"
      data-testid="DomainLockdownTeamTopBarSlim__cta"
    >
      <Typography className={`sm-top-bar-slim--info__cta-text`}>
        {t(COPY.CTA_TEXT)}
      </Typography>
    </Link>
  );

  return (
    <TopBarSlim
      message={t(COPY.MESSAGE, { ctaText })}
      prefix={t(COPY.BOLD_PREFIX)}
    />
  );
};

export default DomainLockdownTeamTopBarSlim;
